export class RefreshFailedError extends Error {
  readonly status: number | undefined;
  readonly refreshToken: string;

  constructor(status: number | undefined, refreshToken: string) {
    super('Could not refresh session.');
    this.name = 'RefreshFailedError';
    this.status = status;
    this.refreshToken = refreshToken;
  }
}

export const shouldSignOutAfterRefreshFailure = (
  error: unknown,
  storedRefreshToken: string | undefined
): boolean => {
  if (!(error instanceof RefreshFailedError) || error.status !== 401) {
    return false;
  }
  return storedRefreshToken === error.refreshToken;
};
